import Web3 from 'web3'
import React from 'react'
import { chainInfo, chainList } from './chainConfUtil'

/**
 * @description: 获取链图标（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {ReactDOM}
 */
export function getChainIcon(chainId) {
  if (chainId) {
    chainId = Web3.utils.toHex(chainId)
    return chainInfo[chainId] && <img src={chainInfo[chainId].logo} alt="" />
  }
  return ''
}

/**
 * @description: 获取链跳转链接（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getChainUrl(chainId) {
  if (chainId) {
    chainId = Web3.utils.toHex(chainId)
    return chainInfo[chainId] && chainInfo[chainId].chainUrl
  }

  return ''
}

/**
 * @description: 获取链合约跳转链接（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getChainContractUrl(chainId) {
  const chain = getChainUrl(chainId)

  if (chain) {
    return `${chain}address/`
  }
  return ''
}

/**
 * @description: 获取链区块浏览器跳转链接（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getChainBlockChainBrowserUrl(chainId) {
  const chain = getChainUrl(chainId)

  if (chain) {
    return `${chain}tx/`
  }
  return ''
}

/**
 * @description: 获取链显示名称（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getChainName(chainId) {
  if (chainId) {
    chainId = Web3.utils.toHex(chainId)
    return chainInfo[chainId] && chainInfo[chainId].network
  }
}

/**
 * @description: 获取链显示名称的 networkId（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getChainNetworkId(network) {
  if (network) {
    const list = chainList()
    const item = list.find((item) => item.network == network) || {}
    return item?.networkId || ''
  }
}

/**
 * @description: 获取下拉框链显示名称（ 正式环境和测试环境通用 ）
 * @param {Number} chainId 当前环境链的id
 * @return {String}
 */
export function getNetworkName(chainId) {
  if (chainId) {
    chainId = Web3.utils.toHex(chainId)
    return chainInfo[chainId] && chainInfo[chainId].networkName
  }
}
